<a class="skip-link visually-hidden-focusable" href="#main-content">Skip to main content</a>

@if (isLoading$ | async) {
  <div class="route-progress" role="progressbar" aria-label="Loading page"></div>
}

<!-- The header shows browser-only state (location, login, cart count), so the server
     can't render what the client will show; hydrating it would leave stale nodes. -->
<app-header ngSkipHydration></app-header>

<main id="main-content" class="app-main page-container" tabindex="-1">
  <router-outlet />
</main>

<app-footer></app-footer>
<app-mobile-bottom-nav></app-mobile-bottom-nav>
